import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Sliding segmented control. The highlight pill's width is 100%/N and it
 * slides via translateX(activeIndex * 100%) — no DOM measurement needed.
 */
const ViewToggle = ({ options, value, onChange }) => {
  const { theme } = useTheme();
  const activeIndex = Math.max(0, options.findIndex((o) => o.value === value));

  return (
    <div className={`relative inline-flex rounded-full border ${theme.border} p-1`} style={{ width: options.length * 108 }}>
      <div
        className={`absolute inset-y-1 rounded-full transition-transform duration-200 ease-out ${theme.buttonPrimary}`}
        style={{ width: `calc(${100 / options.length}% - 4px)`, transform: `translateX(calc(${activeIndex * 100}% + ${activeIndex * 4}px))` }}
      />
      {options.map((opt) => {
        const Icon = opt.icon;
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`relative z-10 flex flex-1 items-center justify-center gap-1.5 rounded-full py-1.5 text-xs font-semibold transition-colors ${
              active ? 'text-white' : theme.textSecondary
            }`}
          >
            {Icon && <Icon size={13} />}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default ViewToggle;
